import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { StyledLink, StyledLinkTheme } from '../StyledLink/StyledLink';

import './SwitchToOldInterfaceLink.css';
import * as keyset from './SwitchToOldInterfaceLink.i18n';

const i18n = i18nFactory(keyset);

export interface SwitchToOldInterfaceLinkProps {
    switchToOldInterface: () => void;
}

export class SwitchToOldInterfaceLink extends React.Component<SwitchToOldInterfaceLinkProps> {
    render() {
        return (
            <div className={Bem.cls('switch-to-old-interface-link')}>
                <span className={Bem.cls('switch-to-old-interface-link', 'text')}>
                    {i18n('switch-to-old-interface')}
                </span>
                <StyledLink
                    cls={Bem.cls('switch-to-old-interface-link', 'elem')}
                    theme={StyledLinkTheme.blue}
                    onClick={this.props.switchToOldInterface}
                >
                    {i18n('switch-to-old-interface-link')}
                </StyledLink>
            </div>
        );
    }
}
